import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react';
import NextLink from '@ui/overrides/next/link';
import { Close } from '@veno-app/icons';
import NextImage from 'next/image';
import React from 'react';

import { Card } from '../Card';
import type { UpdateBannerProps } from './UpdateBanner';

function UpdateBannerDesktop({
  mainImg,
  mainImgProps,
  text,
  secondaryText,
  link,
  isLinkExternal,
  backgroundSize,
  bgImage,
  linkText,
  onClose,
}: UpdateBannerProps) {
  return (
    <Card
      h="116px"
      flexShrink={0}
      mx={6}
      p={2}
      bgPos="calc(100% - 100px)"
      bgImage={bgImage}
      backgroundSize={backgroundSize}
      backgroundImage={bgImage}
      backgroundRepeat="no-repeat"
    >
      <Flex h="full">
        <Flex p={2}>
          <Flex
            flexDir="column"
            justify="space-between"
            gap={4}
            pr={6}
            mr={6}
            borderRight="1px solid #B4C1D5BF"
            pb={2}
          >
            {typeof mainImg === 'string' ? (
              <NextImage alt="banner logo" src={mainImg} {...mainImgProps} />
            ) : (
              <Box textStyle="h3" fontWeight="bold" color="brand-primary">
                {mainImg}
              </Box>
            )}
            <Box>
              <NextLink href={link} passHref>
                <Button
                  size="sm"
                  target={isLinkExternal ? '_blank' : undefined}
                  as="a"
                  variant="primary"
                >
                  {linkText}
                </Button>
              </NextLink>
            </Box>
          </Flex>
          <Flex flexDir="column" gap={2.5} justify="center">
            <Box>
              <Box textStyle="h4">{text}</Box>
            </Box>
            <Flex mt={0.5} justify="space-between">
              <Text textStyle="body" color="text.light">
                {secondaryText}
              </Text>
            </Flex>
          </Flex>
        </Flex>
        <Box ml="auto">
          <Icon
            cursor="pointer"
            as={Close}
            width={6}
            height={6}
            onClick={onClose}
          />
        </Box>
      </Flex>
    </Card>
  );
}

export default UpdateBannerDesktop;
